import React, { useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Whiteboard } from './lib';

const EditorContainer = ({ onClose, onSave, imageUrl}) => {
  const saveRef = useRef(null)
  const [overlayOpen, setOverlayOpen] = useState(false)
  return (
    <div
      style={{
        height: '100dvh',
        paddingTop: 'env(safe-area-inset-top)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      {/* Header - fixed 64px */}
      <div
        style={{
          display: overlayOpen ? 'none' : 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 64,
          minHeight: 64,
          padding: '8px 12px',
          zIndex: 2000,
          background: 'rgba(0,0,0,0.6)',
          pointerEvents: overlayOpen ? 'none' : 'auto',
          flexShrink: 0
        }}
      >
        <CloseIcon onClick={onClose} style={{color: '#fff'}} />
        <button
          onClick={() => saveRef.current.saveImage()}
          style={{
            backgroundColor: '#FBC916',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 600,
            padding: '6px 12px',
            height: 32,
            color: '#000'
          }}
        >
          Done
        </button>
      </div>
      {/* Whiteboard - remaining space */}
      <div
        style={{
          flex: 1,
          width: '100%',
          overflow: 'hidden',
          minHeight: 0
        }}
      >
        <Whiteboard ref={saveRef} onClose={onClose} onSave={onSave} imageUrl={imageUrl} aspectRatio={4 / 3} onOverlayChange={setOverlayOpen} />
      </div>
    </div>
  );
};

export default EditorContainer;
